module.exports = __webpack_public_path__ + "static/media/instagram.7848c299.svg";